import React, { useEffect, useState } from 'react';
import API_BASE from '../config';
import { formatBuildStamp } from '../lib/buildStamp';

/**
 * Sticky chrome footer: short deploy SHA from GET /diagnostics/build.
 * Visible on every tab — not Settings-only.
 */
export default function BuildStamp() {
  const [label, setLabel] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      let sha = '';
      try {
        const res = await fetch(`${API_BASE}/diagnostics/build`, {
          headers: { 'ngrok-skip-browser-warning': 'true' },
        });
        if (res.ok) {
          const data = await res.json().catch(() => ({}));
          sha = String(
            (data && (data.sha_short || data.sha || data.commit || data.revision)) || '',
          );
        }
      } catch (_) { /* show version unavailable */ }
      if (!cancelled) setLabel(formatBuildStamp({ sha }));
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div
      className="app-build-footer"
      data-testid="build-stamp"
      aria-label="Build version"
    >
      {label}
    </div>
  );
}
